import { CapoPlugin } from "/codebuild/output/src1392998611/src/node_modules/@unhead/vue/dist/index.mjs";
export default import.meta.server ? [CapoPlugin({ track: true })] : [];